import * as React from "react";
import { DayPicker } from "react-day-picker";

import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/utils/core/generalUtils";
// import { selectWorkspaceTimeZone } from "@/redux/slices/userSlice";

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

const Calendar = ({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps): React.JSX.Element => {
  // const timezone = useAppSelector(selectWorkspaceTimeZone);

  return (
    <DayPicker
      // timeZone={timezone}  TODO: uncomment this when we fix the timezone issue
      showOutsideDays={showOutsideDays}
      className={cn("p-3", className)}
      classNames={{
        months:
          "flex flex-col sm:flex-row space-y-4 space-x-4 sm:space-y-0 justify-center",
        month: "flex flex-col items-center space-y-4",
        month_caption: "flex justify-center pt-1 relative items-center",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-sm font-medium",
        nav: "space-x-1 flex items-center",
        nav_button: cn(
          buttonVariants({ variant: "outline" }),
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100",
        ),
        weekdays: "text-muted-foreground font-light text-[0.9rem]",
        weekday: "font-normal text-[0.8rem]",
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        button_previous: cn(
          buttonVariants({ variant: "outline" }),
          "h-5 w-5 bg-transparent p-0 opacity-50 hover:opacity-100 absolute left-5 top-5",
        ),
        button_next: cn(
          buttonVariants({ variant: "outline" }),
          "h-5 w-5 bg-transparent p-0 opacity-50 hover:opacity-100 absolute right-5 top-5",
        ),
        table: "w-full border-collapse space-y-1",
        head_row: "flex",
        head_cell:
          "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]",
        row: "flex w-full mt-2",
        day: "h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
        day_button: cn(
          buttonVariants({ variant: "ghost" }),
          "h-9 w-9 p-0 font-normal aria-selected:opacity-100",
        ),
        day_range_end: "day-range-end",
        range_start: "bg-primary text-primary-foreground  rounded-md",
        range_end: "bg-primary text-primary-foreground  rounded-md",
        range_middle:
          "aria-selected:bg-accent aria-selected:text-accent-foreground",
        selected:
          " rounded-md  bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
        day_selected:
          "bg-primary  text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
        day_today: "bg-accent text-accent-foreground",
        day_outside:
          "day-outside text-muted-foreground opacity-50 aria-selected:bg-accent/50 aria-selected:text-muted-foreground aria-selected:opacity-30",
        disabled: "text-muted-foreground opacity-50",
        day_range_middle:
          "aria-selected:bg-accent aria-selected:text-accent-foreground",
        outside:
          "day-outside text-muted-foreground opacity-50 aria-selected:bg-accent/50 aria-selected:text-muted-foreground aria-selected:opacity-30",
        today: "bg-gray-200 rounded-md",
        hidden: "invisible",
        ...classNames,
      }}
      // components={{
      //   Chevron: ({ ...props }) =>
      //     props.orientation === "left" ? (
      //       <ChevronLeft className='h-4 w-4' />
      //     ) : (
      //       <ChevronRight className='h-4 w-4' />
      //     ),
      // }}
      {...props}
    />
  );
};
Calendar.displayName = "Calendar";

export { Calendar };
